import { actions } from "./action-list";

export function cityOperatorsFetched(value) {
  return {
    type: actions.CITY_OPERATOR,
    value,
  };
}

export function setSettlementCycle(value) {
  return {
    type: actions.SETTLEMENT_CYCLE,
    value,
  };
}
